import BaseListPresenter from "../../../../base/BaseListPresenter";
import { _chunkArray } from "../../../Finance/Payroll/helper-payroll/HelperFunction";

class PayrollTablePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.view = view;
  }
  init() {
    const { ids, payrollData } = this.view.props;
    console.log("ids", ids);
    this.ids = ids;
    this.payrollData = payrollData;
    this.limit = 100;
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery(chunk) {
    const baseWhere = {
      "employee.id": { $in: chunk },
      ...this.search,
      ...this.filter,
    };
    
    if (this.payrollData?.[0]?.payrollID) {
      baseWhere.payrollID = this.payrollData[0].payrollID;
    }
    const query = {
      where: baseWhere,
      include: this.include,
      limit: 100,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    try {
      this.showProgress();
      this.findObjectUseCase.abort();

      const idChunks = _chunkArray(this.ids, 100);
      const requests = [];

      for (const chunk of idChunks) {
        if (!chunk || chunk.length === 0) continue;
        const query = this.createQuery(chunk);
        requests.push(
          this.findObjectUseCase.execute(collection, query).catch(err => {
            console.error("Error fetching chunk:", err);
            return [];
          })
        );
      }

      const results = await Promise.all(requests);
      const allObjects = [];
      for (let i = 0; i < results.length; i++) {
        const result = results[i];
        for (let j = 0; j < result.length; j++) {
          allObjects.push(result[j]);
        }
      }

      const skip = (this.current - 1) * this.limit;
      const paginatedObjects = allObjects.slice(skip, skip + this.limit);

      this.objects = allObjects;
      this.count = allObjects.length;
      this.view.setCount(allObjects.length);
      this.view.setObjects(paginatedObjects);
      this.view.setCurrent(this.current);
      this.hideProgress();
    } catch (error) {
      console.error("Error in findObjects:", error);
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  setCurrentPage(page) {
    this.current = page;
    this.documents = [];
    this.view.setCurrent(page);
    
    if (this.objects && this.objects.length > 0) {
      const skip = (page - 1) * this.limit;
      const paginatedObjects = this.objects.slice(skip, skip + this.limit);
      this.view.setObjects(paginatedObjects);
    } else {
      this.view.setObjects([]);
      this.findObjects();
    }
  }
}
export default PayrollTablePresenter;
